import React from 'react';

const AlignCenterChunkySvg = (props) => (
    <svg
        className="align-center-chunky_svg__eds-icon--align-center-chunky_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="align-center-chunky_svg__eds-icon--align-center-chunky_bottom"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 17h16v2H4z"
        />
        <path
            className="align-center-chunky_svg__eds-icon--align-center-chunky_middle"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 11h8v2H8z"
        />
        <path
            className="align-center-chunky_svg__eds-icon--align-center-chunky_top"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 5h16v2H4V5z"
        />
    </svg>
);

AlignCenterChunkySvg.displayName = 'AlignCenterChunkySvg';
export default AlignCenterChunkySvg;
